module.exports = __webpack_public_path__ + "media/images/workplace/instructions/knowhowBtn-cb83ade2e528a6c4dc90657993aad638.png";